import useSWRImmutable from 'swr/immutable';
import urlResolver from 'admin/utils/URLResolver';

export const useDemoActivity = (activityId) => {
  const url = urlResolver.reverse('api:demo-activities:object', { activityId });
  const { data: activity, error } = useSWRImmutable(url);

  // hardcode enable_collaborators to false
  // we want this disabled for demo activities
  if (activity) {
    activity.enable_collaborators = false;
  }

  return {
    data: activity,
    error,
    loading: !error && !activity,
  };
};
